// extracted by mini-css-extract-plugin
module.exports = {"root":"Heading_root__STGU8","heading":"Heading_heading__9uBjf","title":"Heading_title__1tHdF","subContainer":"Heading_subContainer__1v29O","subHeading":"Heading_subHeading__3G-Bn"};